import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FileUrlPipeModule } from 'src/app/pipes/file-url-pipe/file-url-pipe.module';
import { AudioPlayerComponent } from './audio-player.component';

@NgModule({
   declarations: [AudioPlayerComponent],
   exports: [AudioPlayerComponent],
   imports: [CommonModule, MatDialogModule, MatButtonModule, FileUrlPipeModule, MatFormFieldModule],
})
export class AudioPlayerModule {}
